(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("icepath"), require("startlibs/lib/lib"), require("redux"));
	else if(typeof define === 'function' && define.amd)
		define("statlibs", ["react", "icepath", "startlibs/lib/lib", "redux"], factory);
	else if(typeof exports === 'object')
		exports["statlibs"] = factory(require("react"), require("icepath"), require("startlibs/lib/lib"), require("redux"));
	else
		root["statlibs"] = factory(root["react"], root["icepath"], root["startlibs/lib/lib"], root["redux"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_15__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 35);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return postFetcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFetcher; });
/* unused harmony export innerFetcher */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return closePopups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return openPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return removeError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return lazyLoad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return removeLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return uiReducer; });
/* harmony export (immutable) */ __webpack_exports__["b"] = arrToMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionHelpers__ = __webpack_require__(6);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var postFetcher = function postFetcher(url, json, extraParams) {
  return innerFetcher(url, json, _extends({
    method: 'POST',
    headers: typeof json === "string" || json.constructor === FormData ? {} : { 'Content-Type': 'application/json; charset=UTF-8' },
    body: typeof json === "string" ? json : json.constructor === FormData ? json : JSON.stringify(json)
  }, extraParams));
};

var addQueryString = function addQueryString(url, obj) {
  return !obj || !Object.keys(obj).length ? url : url + '?' + Object.entries(obj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return v !== undefined && v !== null;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).join('&');
};

var getFetcher = function getFetcher(url, jsonParams, extraParams) {
  return innerFetcher(addQueryString(url, jsonParams), undefined, _extends({
    method: 'GET'
  }, extraParams));
};

var innerFetcher = function innerFetcher(url, json, extraParams) {
  return fetch(url, _extends({
    credentials: 'same-origin'
  }, extraParams)).then(function (e) {
    return e.status >= 400 ? Promise.reject(e.json()) : e.text();
  }).catch(function (e) {
    return e.then ? e.then(function (e) {
      return Promise.reject(e.errors ? e : { errorResponse: e });
    }) : Promise.reject(e);
  }).then(function (e) {
    if (e && typeof e === 'string') {
      try {
        return JSON.parse(e);
      } catch (e) {
        return e;
      }
    } else {
      return e;
    }
  });
};

var formFetch = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('FORM_FETCH', function (s) {
  return s;
}, function (obj, _ref5) {
  var url = _ref5.url;
  return postFetcher(url, obj);
});

var closePopups = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('CLOSE_POPUPS', function () {
  return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"](false);
});
var openPopup = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('OPEN_POPUP', function (chain, id, _ref6) {
  var value = _ref6.value;
  return chain.set(_defineProperty({}, id, value));
});
var popupsReducer = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["g" /* reducerCreator */](false, [closePopups, openPopup]);

var getActionKey = function getActionKey(meta) {
  return meta.actionKey || meta._origin + meta.actionId;
};
var setErrors = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */](__WEBPACK_IMPORTED_MODULE_2__actionHelpers__["e" /* SET_ERRORS */], function (chain, errors, meta) {
  return chain.set(getActionKey(meta), errors);
});
var clearErrors = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */](__WEBPACK_IMPORTED_MODULE_2__actionHelpers__["c" /* CLEAR_ERRORS */], function (chain, key, _ref7) {
  var path = _ref7.path;
  return chain.update([key], function (errorMap) {
    return !path ? false : __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].filter(errorMap || {}, function (v, k) {
      return k.indexOf(path.join('.')) < 0;
    });
  });
});

var removeError = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('REMOVE_ERROR', function (chain, key, _ref8) {
  var errorKey = _ref8.key,
      value = _ref8.value;
  return chain.on(key, function (errorsChain) {
    return errorsChain.filter(errorKey, function (v) {
      return v !== value || !value;
    }).map(function (errorList) {
      return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].filter(errorList, function (e) {
        return e !== '$' + errorKey;
      });
    }).filter(function (errorList) {
      return errorList.length;
    });
  });
});
var errorsReducer = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["g" /* reducerCreator */]({}, [setErrors, removeError, clearErrors]);

var lazyLoadAction = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('LAZY_LOAD', function (chain) {
  return chain;
}, function (url) {
  return postFetcher(url, {});
});
var lazyLoad = function lazyLoad(payload, meta) {
  return lazyLoadAction(payload, _extends({ _dontNotify: true }, meta));
};
lazyLoad.toString = lazyLoadAction.toString;

var addLoading = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */](__WEBPACK_IMPORTED_MODULE_2__actionHelpers__["a" /* ADD_LOADING */], function (chain, _, meta) {
  return chain.set(getActionKey(meta), true);
});
var removeLoading = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */](__WEBPACK_IMPORTED_MODULE_2__actionHelpers__["d" /* REMOVE_LOADING */], function (chain, _, meta) {
  return chain.unset(getActionKey(meta));
});
var loadingsReducer = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["g" /* reducerCreator */]({}, [addLoading, removeLoading]);

var hasFetchedReducer = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["g" /* reducerCreator */](0, []);

var uiReducer = function uiReducer(extraReducers) {
  return __WEBPACK_IMPORTED_MODULE_1_redux__["combineReducers"](_extends({
    openPopup: popupsReducer(),
    errors: errorsReducer(),
    loadings: loadingsReducer(),
    hasFetched: hasFetchedReducer(_defineProperty({}, lazyLoad, function () {
      return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"](Date.now());
    }))
  }, extraReducers));
};

function arrToMap(arr) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "id";

  var map = {};
  for (var i = 0; i < arr.length; i++) {
    map[arr[i][key]] = arr[i];
  }
  map.order = arr.map(function (_) {
    return _[key];
  });
  return map;
}

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_actionHelpers__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StartlibsProvider__ = __webpack_require__(36);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFetcher", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "postFetcher", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "uiReducer", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formFetch", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addLoading", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "clearErrors", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "closePopups", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lazyLoad", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "openPopup", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "removeError", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "removeLoading", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setErrors", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arrToMap", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_UiReducers__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "makeActionCreator", function() { return __WEBPACK_IMPORTED_MODULE_1__reducers_actionHelpers__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reducerCreator", function() { return __WEBPACK_IMPORTED_MODULE_1__reducers_actionHelpers__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AJAX_ERROR", function() { return __WEBPACK_IMPORTED_MODULE_1__reducers_actionHelpers__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setAjaxDefaultError", function() { return __WEBPACK_IMPORTED_MODULE_1__reducers_actionHelpers__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StartlibsProvider", function() { return __WEBPACK_IMPORTED_MODULE_2__StartlibsProvider__["a"]; });






/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StartlibsProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var registeredComponents = {};

var StartlibsProvider = function (_React$Component) {
  _inherits(StartlibsProvider, _React$Component);

  _createClass(StartlibsProvider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_1_startlibs_lib_lib__["fixMediaQuery"]();
    }
  }]);

  function StartlibsProvider(props) {
    _classCallCheck(this, StartlibsProvider);

    var _this = _possibleConstructorReturn(this, (StartlibsProvider.__proto__ || Object.getPrototypeOf(StartlibsProvider)).call(this, props));

    _this.contextConfig = { startlibs: _extends({}, props.config, { __internals: function __internals(k) {
          return registeredComponents[k];
        } }) };
    return _this;
  }

  _createClass(StartlibsProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return this.contextConfig;
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return StartlibsProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

StartlibsProvider.childContextTypes = {
  startlibs: function startlibs() {
    return null;
  }
};

StartlibsProvider.registerInternal = function (key, value) {
  registeredComponents[key] = value;
};

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AJAX_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setAjaxDefaultError; });
/* harmony export (immutable) */ __webpack_exports__["f"] = makeActionCreator;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return reducerCreator; });
/* unused harmony export arrToMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icepath__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var SET_ERRORS = 'SET_ERRORS';
var CLEAR_ERRORS = 'CLEAR_ERRORS';
var REMOVE_LOADING = 'REMOVE_LOADING';
var ADD_LOADING = 'ADD_LOADING';
var AJAX_ERROR = '';
var setAjaxDefaultError = function setAjaxDefaultError(s) {
  return AJAX_ERROR = s;
};

function makeActionCreator(key, reducer, fetcher) {
  var fn = function fn(possiblePayload, possibleActionMeta) {
    return function (dispatch, getState) {
      var payload = (typeof possiblePayload === 'undefined' ? 'undefined' : _typeof(possiblePayload)) !== 'object' || Array.isArray(possiblePayload) || possiblePayload.constructor === Object ? possiblePayload : {};
      var actionMeta = (typeof possibleActionMeta === 'undefined' ? 'undefined' : _typeof(possibleActionMeta)) === 'object' && possibleActionMeta.constructor === Object ? possibleActionMeta : {};
      var meta = _extends({
        _origin: key,
        _payload: payload
      }, actionMeta, {
        actionId: (actionMeta ? actionMeta.actionId : '') || ''
      });
      if (fetcher && !meta._dontFetch) {
        dispatch({ type: CLEAR_ERRORS, payload: meta.actionKey || key + meta.actionId, meta: meta });
        dispatch({ type: ADD_LOADING, meta: meta });
        var fetched = fetcher(payload, actionMeta).then(function (response) {
          if (response.errors) {
            throw response;
          } else {
            dispatch({
              type: key,
              payload: response.success || response,
              meta: _extends({}, meta, response)
            });
          }
          return { success: response.success || response, meta: meta };
        }).catch(function (e) {
          if (e.errors) {
            dispatch({ type: SET_ERRORS, payload: e.errors, meta: meta });
            return { errors: e.errors, meta: meta };
          } else if (e.errorResponse) {
            return { errors: true, response: e.errorResponse, meta: meta };
          } else {
            console.log(e);
            dispatch({ type: SET_ERRORS, payload: { _connection_error_: [AJAX_ERROR] }, meta: _extends({}, meta, { _errorType: e.name }) });
            return { errors: e, meta: meta };
          }
        });
        fetched.then(function (v) {
          return dispatch({ type: REMOVE_LOADING, payload: v, meta: meta });
        });
        return fetched;
      } else {
        dispatch({ type: key, payload: payload, meta: meta });
        return Promise.resolve({ success: payload, meta: meta });
      }
    };
  };
  var actionCreator = fn;
  actionCreator.toString = function () {
    return key;
  };
  actionCreator.reducer = reducer;
  return actionCreator;
}

var reducerCreator = function reducerCreator(initialState, actions) {
  var reducer = actions.reduce(function (acc, action) {
    return _extends({}, acc, _defineProperty({}, action, action.reducer));
  }, {});
  return function (extraReducers) {
    var finalReducer = _extends({}, reducer, extraReducers);
    return function (state, action) {
      return finalReducer[action.type] ? finalReducer[action.type](__WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].chain(state), action.payload, action.meta).value() : state || initialState;
    };
  };
};

function arrToMap(arr) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

  var map = {};
  for (var i = 0; i < arr.length; i++) {
    map[arr[i][key]] = arr[i];
  }
  return map;
}

/***/ })

/******/ });
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/startlibs/lib/index.js
// module id = 5
// module chunks = 4